import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-spinner-loading',
  templateUrl: './shared-spinner-loading.component.html'
})
export class SharedSpinnerLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
